import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Bugsnag from '@bugsnag/js';
import { Routes } from '../../../config/routes';
import { redirecTo } from '../../../utils';
import ButtonCustom from '../__deprecated__/button-custom';
import MessageError from '../message-error';
import l from '../../../lang';
import './styles.scss';

// Props `error`, `info` and `clearError` are injected by the Bugsnag
// react ErrorBoundary when this component is used as its FallbackComponent.
const ErrorView = ({ error, info }) => {
  useEffect(() => {
    // Prefer reporting the real error captured by the ErrorBoundary so that
    // occurrences group by their actual cause instead of a single generic
    // "General error page was displayed." bucket.
    const reportedError = error instanceof Error ? error : new Error('General error page was displayed.');

    Bugsnag.notify(reportedError, event => {
      event.severity = 'error';
      event.context = typeof window !== 'undefined' ? window.location.pathname : undefined;

      event.addMetadata('errorView', {
        displayedGenericErrorPage: true,
        originalErrorMessage: error?.message ?? null,
        originalErrorName: error?.name ?? null,
        // React component stack that led to the error boundary, when available.
        componentStack: info?.componentStack ?? null,
      });

      if (typeof window !== 'undefined') {
        event.addMetadata('page', {
          url: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer || null,
          userAgent: navigator.userAgent,
        });
      }
    });
  }, [error, info]);

  return (
    <div className="error-view" onClick={() => redirecTo(Routes.HOME)}>
      <MessageError />
      <div className="error-view__btn">
        <ButtonCustom text={l('common.return')} onClick={() => redirecTo(Routes.HOME)} />
      </div>
    </div>
  );
};

ErrorView.propTypes = {
  error: PropTypes.instanceOf(Error),
  info: PropTypes.shape({
    componentStack: PropTypes.string,
  }),
};

export default ErrorView;
